import { render, staticRenderFns } from "./EditarLegajo.vue?vue&type=template&id=755a29c4&"
import script from "./EditarLegajo.vue?vue&type=script&lang=js&"
export * from "./EditarLegajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports